export const SAMPLE_HTML = `<style>
  .card {
    font-family: sans-serif;
    padding: 16px;
    border: 1px solid #ddd;
    border-radius: 8px;
  }
  .card h3 {
    margin-top: 0;
  }
  .card .actions {
    display: flex;
    gap: 8px;
    margin-top: 12px;
  }
  .card button,
  .card a.primary {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
  }
  .card .primary {
    background: #4183c4;
    color: #fff;
  }
  .card .secondary {
    background: #f0f0f0;
    color: #333;
  }
  .card a.external {
    color: #4183c4;
    text-decoration: none;
    font-size: 12px;
  }
</style>
<div class="card">
  <h3>埋め込みカードのサンプル</h3>
  <p>サンドボックス内で表示される HTML/CSS ウィジェットです。</p>

  <div class="actions">
    <!-- 同タブ遷移 + GA4 計測: <a href> + class="js-trill-embed-link" + data-trill-* -->
    <a
      class="primary js-trill-embed-link"
      href="https://example.com/landing"
      data-trill-event-category="sample_card"
      data-trill-event-label="primary_cta"
    >
      詳しく見る (same tab)
    </a>

    <!-- 計測のみ (遷移しない): class="js-trill-embed-track" + data-trill-action -->
    <button
      class="secondary js-trill-embed-track"
      data-trill-action="タップ"
      data-trill-event-category="sample_card"
      data-trill-event-label="secondary_action"
      data-trill-non-interaction="false"
    >
      お気に入り
    </button>
  </div>

  <p>
    <!-- 外部サイトを新規タブ表示 + 計測: ネイティブ target=_blank + class="js-trill-embed-track" -->
    <a
      class="external js-trill-embed-track"
      href="https://example.com/external"
      target="_blank"
      rel="noopener"
      data-trill-action="タップ"
      data-trill-event-category="sample_card"
      data-trill-event-label="external_link"
      data-trill-link-url="https://example.com/external"
    >
      外部サイトを新規タブで開く →
    </a>
  </p>
</div>`

export const SAMPLE_PLACEHOLDER = `例:
<style>
  .card {
    padding: 16px;
    border: 1px solid #ddd;
  }
</style>
<div class="card">
  <h3>タイトル</h3>
  <p>本文</p>

  <!-- 同タブ遷移 + 計測: <a href> + class="js-trill-embed-link" -->
  <a
    class="js-trill-embed-link"
    href="https://example.com/landing"
    data-trill-event-category="sample_card"
    data-trill-event-label="primary_cta"
  >
    詳しく見る
  </a>

  <!-- 計測のみ: class="js-trill-embed-track" + data-trill-action -->
  <button
    class="js-trill-embed-track"
    data-trill-action="タップ"
    data-trill-event-category="sample_card"
    data-trill-event-label="cta_button"
  >
    CTA
  </button>
</div>

許可されるタグ: div, span, p, h1-h6, ul/ol/li, a, img, button, style, svg,
table 系。許可されない: script (実体), iframe, form, object など。

クリック計測は class="js-trill-embed-track" + data-trill-* 属性で指定。
同タブ遷移は <a href="..." class="js-trill-embed-link"> を使用。
(inline onclick は広告ブロッカーの CSP で無効化されるため非推奨)

- data-trill-action サポート済み: タップ, 完読, page_view
- data-trill-* パラメーター: data-trill-event-category, data-trill-event-label,
  data-trill-link-url, data-trill-non-interaction (data-trill-foo-bar → params.foo_bar)
- js-trill-embed-link の href: http/https の絶対 URL のみ (javascript:, data:, file:,
  localhost などは reject)。1 ページロードあたり 1 回まで navigate 可能。
- data-trill-* を併記すると trillTrack タップ も自動発火し link_url が自動補完されます。

javascript:, vbscript:, expression(...), <script>, <iframe> などは禁止。`
